import { ReactNode } from 'react';

import { Flex, type FlexProps } from '@spotify-internal/encore-web';

export type FormFieldsBoxProps = {
  children?: ReactNode;
  gap?: FlexProps['gap'];
  direction?: 'row' | 'column';
  className?: string;
};

export const FormFieldsBox = ({
  children,
  gap = 'base',
  direction = 'column',
  className,
}: FormFieldsBoxProps) => (
  <Flex direction={direction} gap={gap} className={className}>
    {children}
  </Flex>
);
